'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 73px;\n  border-radius: 4px;\n  background-color: #f74c49;\n  padding: 16px;\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 73px;\n  border-radius: 4px;\n  background-color: #f74c49;\n  padding: 16px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _View = require('../View');

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorBox = (0, _styledComponents2.default)(_View2.default)(_templateObject);

exports.default = errorBox;